"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncompleteCartState = /** @class */ (function () {
    function IncompleteCartState() {
        this.isCartIncomplete = false;
    }
    return IncompleteCartState;
}());
exports.default = IncompleteCartState;
//# sourceMappingURL=IncompleteCartState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/IncompleteCartState.js
// module id = 2329
// module chunks = 8